import React from 'react';
import { Button } from 'antd';
import 'antd/dist/antd.css';
import { Link, useRouteMatch } from 'react-router-dom';
import { FaUserEdit, FaUserMinus } from 'react-icons/fa';

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface IOptionsProps {}

export const OptionEcole = props => {
  const { url } = useRouteMatch();
  const { match } = props;
  return (
    <div>
      <h4 className="pt-4">Options</h4>
      <Button type="primary" style={{ borderRadius: 16 }}>
        <Link to={`${match.url}/edit`} id="jh-create-entity" data-cy="entityCreateButton">
          <FaUserEdit title="editer" />
          &nbsp; Modifier
        </Link>
      </Button>
      <Button style={{ marginTop: 5, backgroundColor: '#dc3545', color: 'white', borderRadius: 16 }}>
        <Link to={`${match.url}/delete`} id="jh-create-entity" data-cy="entityCreateButton">
          <FaUserMinus title="delete" />
          &nbsp; Supprimer
        </Link>
      </Button>
    </div>
  );
};

export default OptionEcole;
